import script from "./Banner.vue?vue&type=script&setup=true&lang=js"
export * from "./Banner.vue?vue&type=script&setup=true&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=066e7542&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\33\\Desktop\\2024\\block-explorer-ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066e7542"]])

export default __exports__